import { StrictMode, Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';

import { ErrorBoundary } from './components/ErrorBoundary';
import './styles/globals.css';

/**
 * Entry point splits at the URL, not inside the router: the public /board
 * kiosk loads BoardRoot (no AuthProvider, no oidc, no console pages) while
 * everything else loads the full ConsoleRoot. Both are lazy so the entry chunk
 * stays tiny and Rollup can keep the auth stack out of the board's graph
 * entirely. Do not add static imports of ./auth/* or ./App here.
 */
// Two separate lazy() calls, NOT one factory with a ternary: Vite attaches a
// preload-deps list per dynamic-import callsite, and a shared factory gets the
// UNION of both branches — which made the kiosk prefetch ConsoleRoot + oidc
// anyway (verified in the built entry chunk). Split callsites, split deps.
const isBoard = window.location.pathname.startsWith('/board');
const Root = isBoard
  ? lazy(() => import('./BoardRoot'))
  : lazy(() => import('./ConsoleRoot'));

function BootFallback() {
  return (
    <div className="grid h-screen place-items-center font-mono text-xs uppercase tracking-widest text-ink-faint">
      surfacing…
    </div>
  );
}

const root = createRoot(document.getElementById('root')!);
root.render(
  <StrictMode>
    <ErrorBoundary label="root">
      <Suspense fallback={<BootFallback />}>
        <Root />
      </Suspense>
    </ErrorBoundary>
  </StrictMode>,
);
